require("./sass/accounts.sass");

module.exports = {
	// render react component
	renderRC: require("sma.admin/components/react/render").default,
	components: {
		Loader: require("sma.admin/components/loader"),
		CookieBanner: require("sma.common/components/cookie_banner"),
		Rely: require("sma.admin/components/rely"),
		FileUploader: require("sma.common/components/image_uploader").FileUploader,
		DatePicker: require("sma.admin/components/datepicker"),
		TimePicker: require("sma.admin/components/timepicker"),
		Navigation: require("sma.common/components/react/components/Navigation/Navigation"),
	},
	oneTrust: require("sma.common/components/one_trust"),

	Registration: require("sma.accounts/register"),

	Account: require("sma.accounts/account").Account,
	accountSettings: require("sma.accounts/react/AccountSettings"),
	CancelDeleteAccount: require("sma.accounts/account").CancelDeleteAccount,

	Strength: require("sma.common/strength").Strength,
	PasswordEye: require("sma.common/strength").PasswordEye,

	Rely: require("sma.admin/components/rely"),
	Authentication: require("sma.accounts/react/Authentication/Authentication"),

	amplitude: require("sma.common/components/amplitude"),
};
